import mockLinkLandingPagesData from "../data/mockData/linkLandingPagesData";
import { isBrowserSessionDemo, isDemoMode } from "./demoConfig";

const BROWSER_SESSION_LANDING_KEY = "wl_bs_landing_extras";

function normalizeBackUrl(value) {
  return String(value || "").trim().toLowerCase();
}

function getBrowserSessionLandingRows() {
  if (typeof sessionStorage === "undefined") {
    return [];
  }
  try {
    const raw = sessionStorage.getItem(BROWSER_SESSION_LANDING_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function getAllLandingRowsForValidation() {
  if (!(isDemoMode() || isBrowserSessionDemo())) {
    return [];
  }
  return [...(mockLinkLandingPagesData || []), ...getBrowserSessionLandingRows()];
}

export function validateBackUrlWithMockData(backUrl, excludeBackUrl = "") {
  const candidate = normalizeBackUrl(backUrl);
  const excluded = normalizeBackUrl(excludeBackUrl);

  if (!candidate) {
    return {
      valid: false,
      message: "Back Url is required",
    };
  }

  const exists = getAllLandingRowsForValidation().some(row => {
    const rowBackUrl = normalizeBackUrl(row?.back_url);
    if (!rowBackUrl) {
      return false;
    }
    if (excluded && rowBackUrl === excluded) {
      return false;
    }
    return rowBackUrl === candidate;
  });

  if (exists) {
    return {
      valid: false,
      message:
        "Oops! This back url is already associated with another landing page. Please try another back url.",
    };
  }

  return {
    valid: true,
    message: "Back url is available",
  };
}
